import { render } from "./OJTOrgs.vue?vue&type=template&id=7f3f59c8"
import script from "./OJTOrgs.vue?vue&type=script&lang=js"
export * from "./OJTOrgs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__